import { all, fork } from "@redux-saga/core/effects";
import rootFlowDesignerSaga from "./flowDesigner";
import rootPortalSaga from "./portal";

export default function* rootSaga() {
  yield all([
    fork(rootFlowDesignerSaga),
    fork(rootPortalSaga)
  ])
}